import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

import Echo from 'laravel-echo';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
  private echo: Echo | null = null;

  private constructor(
    protected _http: HttpClient,
    protected authService: AuthenticationService
  ) {}

  public _initWebSocket() {
    const token = this.authService.currentToken;
    const wsConfig = environment.pusherWsBroadcast;
    this.echo = new Echo({
      ...wsConfig,
      bearerToken: token,
    });
  }

  public subscribeToPrivateNotificationsChannel(
    userId: number,
    addNotificationToUI: any
  ) {
    if (!this.echo) this._initWebSocket();
    const channelName = `user-notifications.${userId}`;
    this.echo
      .private(channelName)
      .listen('.new-notification', (notification) =>
        addNotificationToUI(notification)
      );
  }

  public isLoaded() {
    return this.echo ? true : false;
  }

  public disconnect() {
    if (!this.echo) return;
    this.echo.disconnect();
    this.echo = null;
  }
}

